export default {
  '9x16': { width: 0.565, height: 1, orientation: 'portrait' },
  '3x4': { width: 0.75, height: 1, orientation: 'portrait' },
  '16x9': { width: 16 / 9, height: 0.3, orientation: 'landscape' },
};
